var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_976_24011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 4.1977C4.40039 3.77524 4.51833 3.45813 4.7085 3.25745C4.71121 3.2552 4.71525 3.25533 4.7178 3.25786L13.3568 11.837C13.3911 11.8712 13.4104 11.9173 13.4104 11.9655C13.4104 12.0136 13.3911 12.0598 13.3568 12.094L4.71745 20.6727C4.71495 20.6752 4.71097 20.6753 4.70825 20.6732C4.51823 20.4726 4.40039 20.1562 4.40039 19.7332V4.1977ZM16.4322 14.8753C16.4322 14.8753 16.432 14.8753 16.4319 14.8754C16.4189 14.8824 16.4026 14.8802 16.392 14.8696L13.5979 12.0938C13.5636 12.0596 13.5443 12.0135 13.5443 11.9653C13.5443 11.9172 13.5636 11.871 13.5979 11.8368L16.3929 9.06146C16.4031 9.05139 16.4189 9.04927 16.4315 9.05643L19.8929 11.0093C20.3749 11.2812 20.6004 11.6303 20.6004 11.9658C20.6004 12.3011 20.3747 12.6505 19.8929 12.9229L16.4322 14.8753Z",
    fill: "white",
    stroke: "#131313",
    strokeWidth: 0.153671
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_976_24011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4641 14.933L13.476 11.9658L4.66016 20.7206C4.98557 21.0634 5.52391 21.1056 6.13017 20.7642L16.4641 14.933Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4767 12.0605L4.75586 20.7209C5.05668 20.9925 5.53676 21.0232 6.09772 20.7073M13.4767 12.0605L6.09772 20.7073M13.4767 12.0605L16.3556 14.9192L6.09772 20.7073",
    stroke: "#131313",
    strokeWidth: 0.153671
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4774 11.8742L4.75586 3.2138C5.05673 2.94213 5.53684 2.91093 6.09774 3.22742L16.3557 9.01494L13.4774 11.8742Z",
    fill: "white",
    stroke: "#131313",
    strokeWidth: 0.153671
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_976_24011",
    x: 4.32324,
    y: 2.80068,
    width: 16.3535,
    height: 18.3332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.122168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_24011"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.122168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_976_24011",
    result: "effect2_dropShadow_976_24011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_976_24011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_976_24011",
    x: 4.66016,
    y: 11.8437,
    width: 11.8037,
    height: 9.15635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.122168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_24011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_976_24011",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.05570b8b05e77013b6421a2a3d9af233.svg";
export { ForwardRef as ReactComponent };